import Vue from 'vue';

export default class SuperRepository {
  baseUri () { return '' }
  reportUri () { return 'reports' }
  httpClient () { return Vue.prototype.$http }
  reportHttpClient () { return Vue.prototype.$reportsHttp }

  list = async (params) => {
    const response = await this.httpClient().get(`${this.baseUri()}`, params);
    const pagination = response?.data?.pagination;
    if (
      params?.pagination &&
      pagination?.total > 0 &&
      pagination.currentPage > pagination.maxPageNumber
    ) {
      return this.httpClient().get(`${this.baseUri()}`, {
        ...params,
        pagination: { ...params.pagination, page: 1 },
      });
    }
    return response;
  };
  get = async (id, params = {}) => this.httpClient().get(`${this.baseUri()}/${id}`,params);
  post = async (data, params) => this.httpClient().post(`${this.baseUri()}`, data, params);
  patch = async (id, data, params) => this.httpClient().patch(`${this.baseUri()}/${id}`, data, params);
  put = async (id, data, params) => this.httpClient().put(`${this.baseUri()}/${id}`, data, params);
  delete = async (id) => this.httpClient().delete(`${this.baseUri()}/${id}`);
  query = async (path, params, config) => this.httpClient().request(`${this.baseUri()}/${path}`, params, config);
}
